(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bj-policy"] && !Shopify.designMode) return;
  try {
    (() => {
  const enhance = (scope = document) => {
    scope.querySelectorAll('[data-bj-policy]').forEach((root, rootIndex) => {
      if (root.dataset.policyReady) return;
      root.dataset.policyReady = 'true';
      const wrap = root.querySelector('.bj-policy__wrap');
      const content = root.querySelector('[data-policy-content]');
      if (!content || root.classList.contains('bj-policy--privacy-choices')) return;
      if (root.classList.contains('bj-policy--native')) {
        const title = content.querySelector('.shopify-policy__title');
        const body = content.querySelector('.shopify-policy__body .rte');
        if (!title || !body) return;
        wrap.prepend(title);
        content.replaceChildren(...body.childNodes);
      }
      if (content.querySelector('form,input,select,textarea,iframe')) return;
      const headings = [...content.children].filter(node => node.tagName === 'H2');
      if (!headings.length) return;
      const accordion = root.hasAttribute('data-policy-accordion');
      let chapter, target;
      [...content.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim() && !chapter) return;
        const heading = node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2';
        if (!chapter || heading) {
          chapter = document.createElement(accordion && heading ? 'details' : 'section');
          chapter.className = accordion && heading ? 'bj-policy__question' : 'bj-policy__chapter';
          content.append(chapter);
          target = chapter;
          if (accordion && heading) {
            const summary = document.createElement('summary');
            summary.append(node);
            target = document.createElement('div');
            chapter.append(summary, target);
            return;
          }
        }
        target.append(node);
      });
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `bj-policy-${rootIndex}-${index + 1}`;
        if (!accordion) heading.parentElement.setAttribute('aria-labelledby', heading.id);
      });
      content.querySelectorAll('.bj-policy__chapter').forEach(section => {
        const markets = [...section.children].filter(node => node.tagName === 'P' && node.children.length === 1 && node.firstElementChild.tagName === 'STRONG' && /\b(USD|CAD|GBP|AUD)\b/.test(node.textContent) && node.nextElementSibling?.tagName === 'UL');
        if (markets.length < 2) return;
        const grid = document.createElement('div');grid.className = 'bj-policy__markets';markets[0].before(grid);
        markets.forEach(heading => {
          const rates = heading.nextElementSibling;
          const market = document.createElement('div');market.className = 'bj-policy__market';market.append(heading,rates);grid.append(market);
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => enhance(),{once:true});
  else enhance();
  document.addEventListener('shopify:section:load',event => enhance(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
